<template>
    <div class="calendar-item-details">
        <template v-if="isAppointment(item)"><!-- Appointment -->
            <div class="calendar-item-title">
                {{item.name}}
            </div>
            <div v-if="item.abstract"
                class="calendar-item-abstract"
                v-html="item.abstract"></div>
        </template>

        <template v-else>
            <div class="calendar-item-title calendar-item-name">{{item.other_name}}</div>
            <div v-if="item.other_name != item.other_organisation_name" 
                class="calendar-item-organisation-name">{{item.other_organisation_name}}</div>
            <ProfileFields :fields="item.other_fields" />
        </template>
    </div>
</template>
<script>
import {isAppointment} from '@/utils/Filter';
import ProfileFields from '@/components/ProfileFields';

export default {
    name: 'CalendarItemDetails',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    components: {
        ProfileFields,
    },
    methods: {
        isAppointment,
    },
}
</script>
<style>

</style>